import axios, { AxiosResponse } from 'axios';
import { TextField, useMediaQuery } from '@mui/material';
import { breakpoints } from '../../constants';
import { Row } from '../Row';
import { TFormValues } from '../../types';

interface IProps {
    formValues: TFormValues;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

interface IPostcodeRequest {
    zipCode: string;
    houseNumber: string;
}

interface IPostcodeResponse {
    city: string;
    street: string;
}

export const RelocationAddressSection = ({
    formValues,
    setFieldValue,
}: IProps) => {
    const mediumBreakpoint = useMediaQuery(`(${breakpoints.mediumMin})`);

    const handleHouseNumberBlur = () => {
        if (
            !process.env.REACT_APP_POSTCODE_API_URL ||
            !formValues.newZipcode ||
            !formValues.newHouseNumber
        )
            return;

        axios
            .post<IPostcodeRequest, AxiosResponse<IPostcodeResponse>>(
                process.env.REACT_APP_POSTCODE_API_URL,
                {
                    zipCode: formValues.newZipcode,
                    houseNumber: formValues.newHouseNumber,
                }
            )
            .then((res) => {
                const { street, city } = res.data;

                setFieldValue('newStreet', street);
                setFieldValue('newCity', city);
            });
    };

    return (
        <>
            <Row>
                <TextField
                    required
                    id={formValues.newZipcode}
                    label="Postcode"
                    value={formValues.newZipcode}
                    onChange={(e) =>
                        setFieldValue('newZipcode', e.target.value)
                    }
                />
                <TextField
                    required
                    id={formValues.newHouseNumber}
                    label="Huisnummer"
                    sx={{ margin: `${mediumBreakpoint && '0 10px'}` }}
                    value={formValues.newHouseNumber}
                    onBlur={handleHouseNumberBlur}
                    onChange={(e) =>
                        setFieldValue('newHouseNumber', e.target.value)
                    }
                />
                <TextField
                    id={formValues.newHouseNumberAddition}
                    label="Toevoeging"
                    value={formValues.newHouseNumberAddition}
                    onChange={(e) =>
                        setFieldValue('newHouseNumberAddition', e.target.value)
                    }
                />
            </Row>
            <TextField
                required
                id={formValues.newStreet}
                label="Straat"
                value={formValues.newStreet}
                onChange={(e) => setFieldValue('newStreet', e.target.value)}
            />
            <TextField
                required
                id={formValues.newCity}
                label="Plaats"
                value={formValues.newCity}
                onChange={(e) => setFieldValue('newCity', e.target.value)}
            />
        </>
    );
};
